import React from "react";

import StyledLabel from "../../config/components/StyledLabel";

const Label = ({ name, text }) => {
  return <StyledLabel className="p-0" fontSize="14px" textAlign="left"  htmlFor={name}>{text}</StyledLabel>;
};

export default Label;
